import React from "react";
import { adviceImg1, adviceImg2, adviceImg3 } from "../..";
const adviceCard = [
  {
    id: 0,
    card_img: adviceImg1,
    card_title: "Top Cyber Threats and How to Prevent Them",
    card_link: "#",
  },
  {
    id: 1,
    card_img: adviceImg2,
    card_title: "How to Strengthen Your Cloud Data Protection",
    card_link: "#",
  },
  {
    id: 2,
    card_img: adviceImg3,
    card_title: "Smart Ways to Reduce Risk Without Increasing Spend",
    card_link: "#",
  },
];
function AdviceCard() {
  return (
    <div className="adviceCardsSection">
      <div className="container">
        <div className="row">
          {adviceCard.map((item, index) => (
            <div className="outerCardWrap col-md-4" key={index}>
              <div className="innerCardWrap">
                <div className="cardImageWrap">
                  <a href={item.card_link} target="_blan">
                    <img
                      src={item.card_img}
                      alt={item.card_title}
                      className="img-fluid"
                    />
                    <div className="overlay"></div>
                  </a>
                </div>
                <div className="cardTitleWrap">
                  <a href={item.card_link} target="_blan">
                    <h3>{item.card_title}</h3>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdviceCard;
